export default __webpack_public_path__ + "static/media/motor1.fc79818d.png";